/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisterMobilePushTokenRequest
 */
export interface RegisterMobilePushTokenRequest {
    /**
     * Push provider this token is for. Only apns is sent today.
     * @type {string}
     * @memberof RegisterMobilePushTokenRequest
     */
    platform: RegisterMobilePushTokenRequestPlatformEnum;
    /**
     * Device token from the OS. For APNs this is the hex string from application(_:didRegisterForRemoteNotificationsWithDeviceToken:).
     * 
     * @type {string}
     * @memberof RegisterMobilePushTokenRequest
     */
    token: string;
    /**
     * Which APNs gateway the token is valid for. Debug builds register sandbox; TestFlight/App Store builds register production.
     * 
     * @type {string}
     * @memberof RegisterMobilePushTokenRequest
     */
    environment: RegisterMobilePushTokenRequestEnvironmentEnum;
    /**
     * User-facing device name for the admin view, e.g. "Jim's iPhone".
     * @type {string}
     * @memberof RegisterMobilePushTokenRequest
     */
    deviceName?: string;
    /**
     * Hardware identifier, e.g. "iPhone16,2".
     * @type {string}
     * @memberof RegisterMobilePushTokenRequest
     */
    deviceModel?: string;
    /**
     * OS version, e.g. "18.5".
     * @type {string}
     * @memberof RegisterMobilePushTokenRequest
     */
    osVersion?: string;
    /**
     * App version + build, e.g. "1.0.3 (42)".
     * @type {string}
     * @memberof RegisterMobilePushTokenRequest
     */
    appVersion?: string;
}


/**
 * @export
 */
export const RegisterMobilePushTokenRequestPlatformEnum = {
    Apns: 'apns',
    Fcm: 'fcm'
} as const;
export type RegisterMobilePushTokenRequestPlatformEnum = typeof RegisterMobilePushTokenRequestPlatformEnum[keyof typeof RegisterMobilePushTokenRequestPlatformEnum];

/**
 * @export
 */
export const RegisterMobilePushTokenRequestEnvironmentEnum = {
    Sandbox: 'sandbox',
    Production: 'production'
} as const;
export type RegisterMobilePushTokenRequestEnvironmentEnum = typeof RegisterMobilePushTokenRequestEnvironmentEnum[keyof typeof RegisterMobilePushTokenRequestEnvironmentEnum];


/**
 * Check if a given object implements the RegisterMobilePushTokenRequest interface.
 */
export function instanceOfRegisterMobilePushTokenRequest(value: object): value is RegisterMobilePushTokenRequest {
    if (!('platform' in value) || value['platform'] === undefined) return false;
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('environment' in value) || value['environment'] === undefined) return false;
    return true;
}

export function RegisterMobilePushTokenRequestFromJSON(json: any): RegisterMobilePushTokenRequest {
    return RegisterMobilePushTokenRequestFromJSONTyped(json, false);
}

export function RegisterMobilePushTokenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterMobilePushTokenRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'platform': json['platform'],
        'token': json['token'],
        'environment': json['environment'],
        'deviceName': json['deviceName'] == null ? undefined : json['deviceName'],
        'deviceModel': json['deviceModel'] == null ? undefined : json['deviceModel'],
        'osVersion': json['osVersion'] == null ? undefined : json['osVersion'],
        'appVersion': json['appVersion'] == null ? undefined : json['appVersion'],
    };
}

  export function RegisterMobilePushTokenRequestToJSON(json: any): RegisterMobilePushTokenRequest {
      return RegisterMobilePushTokenRequestToJSONTyped(json, false);
  }

  export function RegisterMobilePushTokenRequestToJSONTyped(value?: RegisterMobilePushTokenRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'platform': value['platform'],
        'token': value['token'],
        'environment': value['environment'],
        'deviceName': value['deviceName'],
        'deviceModel': value['deviceModel'],
        'osVersion': value['osVersion'],
        'appVersion': value['appVersion'],
    };
}

